<template>
  <PageTemplate>
    <div class="row">
      <div class="col-md-6">
        <h1> {{ getTitle() }}</h1>
      </div>
      <div
        v-if="!isCurrentRoleIsTA_ADMIN()"
        class="col-md-6"
      >
        <v-button-group is-right>
          <v-button @click="redirect('/admin/manage-committees')">
            Manage Forum Admin
          </v-button>
        </v-button-group>
      </div>
    </div>
    <fieldset class="fieldset">
      <v-input-wrap prefix="search">
        <v-input
          type="search"
          :value="searchKeyword"
          placeholder="Search by name, email, phone, title or user ID"
          @input="filter"
        />
      </v-input-wrap>
    </fieldset>
    <v-card-body>
      <p class="text-muted mb-3">
        Showing {{ users.length }} of {{ total }} users
      </p>
      <div class="row">
        <div
          v-for="user in users"
          :key="user.id"
          class="d-flex col-md-6 col-lg-4 col-xl-3"
        >
          <v-member
            :name="user.first_name + ' ' +user.last_name"
            :title="user.title || 'General'"
            :phone="user.mobile_number"
            :email="user.email"
            :activated="user.activated"
            :admin="user.committeeAdmin.length"
            :link="'/admin/user/'+user.id"
          />
        </div>
        <div
          v-if="users.length === 0"
          class="col-12"
        >
          <p class="mb-0 text-muted">
            No users found{{ searchKeyword ? ' for "' + searchKeyword + '"' : '' }}.
          </p>
        </div>
      </div>
      <v-pagination
        v-if="total > 0"
        :initial-current-page="page"
        :initial-rows-per-page="perPage"
        :count="total"
        :page-changed="pageChanged"
        :per-page-changed="perPageChanged"
      />
    </v-card-body>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import {buildBreadCrumb} from "@/common/tableFunctions"
  import {GET_MEMBERS} from "@/store/actions.type";
  import CardBody from "@/atoms/CardBody";
  import Member from "@/molecules/Member";
  import Pagination from "@/molecules/Pagination";
  import InputWithIcon from "@/molecules/InputWithIcon";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Button from "@/atoms/Button";
  import Input from "@/atoms/Input";
  import {mapState} from "vuex";
  import {GET_ALL_USERS} from "../../store/actions.type";
import constants from '../../common/constants';

  export default {
    name: "Users",
    components: {
      "v-card-body": CardBody,
      "v-member": Member,
      "v-pagination": Pagination,
      "v-input-wrap": InputWithIcon,
      "v-button-group": ButtonGroup,
      "v-button": Button,
      "v-input": Input,
      PageTemplate
    },
    data: () => ({
      searchKeyword: '',
      searchTimer: null
    }),
    computed: {
      ...mapState({
        users: state => state.userRequest.currentUsers,
        total: state => state.userRequest.total,
        page: state => state.userRequest.page,
        perPage: state => state.userRequest.perPage,
      }),
    },
    mounted() {
      this.updateBreadCrumb();
      this.getUsers();
    },
    beforeDestroy() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['All Users'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      filter: function(searchTerm) {
        this.searchKeyword = (searchTerm || '').trim().replace(/\s+/g, " ");
        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(() => {
          this.$store.dispatch(GET_ALL_USERS, {
            paginated: true,
            page: 1,
            perPage: this.perPage,
            search: this.searchKeyword
          });
        }, 300);
      },
      getUsers: function () {
        this.$store.dispatch(GET_ALL_USERS, {
          paginated: true,
          page: this.page,
          perPage: this.perPage,
          search: this.searchKeyword
        })
      },
      pageChanged: function (page) {
        if (page.currentPage > 0) {
          this.$store.dispatch('updateUsersPage', page.currentPage)
        }
      },
      perPageChanged: function (perPage) {
        if (perPage.currentPerPage > 0) {
          this.$store.dispatch('updateUsersPerPage', perPage.currentPerPage)
        }
      },
      redirect:function(router){
        this.$router.push(router);
      },
      getTitle: function() {
        if(this.isCurrentRoleIsTA_ADMIN()) {
          return "All TA Users";
        }
        return "All Users";
      },
      isCurrentRoleIsTA_ADMIN: function() {
        return constants.NATA_ROLE_TA_ADMIN === localStorage.getItem(constants.CURRENT_ROLE);
      }
    }
  }
</script>
